import { AuthorizeService as AdminAuthorizeService } from '@acme/api/admin';
import {
  AuthorizeService as ClientAuthorizeService,
  RoleEnum,
} from '@acme/api/client';
import { Certificate, createAttachedSignature } from 'crypto-pro';

export const getAuthSecret = async (cert: Certificate) => {
  const response = await ClientAuthorizeService.postApiV1AuthorizeSecret({
    requestBody: { certificateBase64: await cert.exportBase64() },
  });

  if (!response.isSuccess || !response.data || !response.data.secret) {
    throw new Error(response.errorText || 'Auth secret error');
  }

  return response.data;
};

export const getAuthToken = async (
  cert: Certificate,
  secret: string,
  role?: RoleEnum,
  password?: string
): Promise<
  Awaited<ReturnType<typeof ClientAuthorizeService.postApiV1AuthorizeToken>>
> => {
  const sign = await createAttachedSignature(cert.thumbprint, secret);
  const tokenResponse = await ClientAuthorizeService.postApiV1AuthorizeToken({
    requestBody: {
      attachedSignatureBase64: sign,
      roleId: role,
      password: password,
    },
  });

  return tokenResponse;
};

export const getAuthSecretAdmin = async (cert: Certificate) => {
  const response = await AdminAuthorizeService.postApiAdminV1AuthorizeSecret({
    requestBody: { certificateBase64: await cert.exportBase64() },
  });

  if (!response.isSuccess || !response.data || !response.data.secret) {
    throw new Error(response.errorText || 'Auth secret error');
  }

  return response.data;
};

export const getAuthTokenAdmin = async (
  cert: Certificate,
  secret: string,
  role?: RoleEnum,
  password?: string
): Promise<
  Awaited<ReturnType<typeof AdminAuthorizeService.postApiAdminV1AuthorizeToken>>
> => {
  const sign = await createAttachedSignature(cert.thumbprint, secret);
  const tokenResponse =
    await AdminAuthorizeService.postApiAdminV1AuthorizeToken({
      requestBody: {
        attachedSignatureBase64: sign,
        roleId: role,
        password: password,
      },
    });

  return tokenResponse;
};
